import {useState, useEffect} from 'react';

import PartyMgmtAPI from './PartyMgmtAPI';
export default function PartyMgmtActionImpl(){

    return (
        <>
        <PartyMgmtAPI/>
        </>
    )
}